import { render, staticRenderFns } from "./AcademicPlantResearchersRequests.html?vue&type=template&id=474437b9&scoped=true&external"
import script from "./AcademicPlantResearchersRequests.vue?vue&type=script&lang=js"
export * from "./AcademicPlantResearchersRequests.vue?vue&type=script&lang=js"
import style0 from "./AcademicPlantResearchersRequests.scss?vue&type=style&index=0&id=474437b9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474437b9",
  null
  
)

export default component.exports